<div class="image">
  <img [src]="`assets/results/result_${result()}.jpg`">
</div>

<div class="result">
  <header>
    <span class="label">RÉSULTAT</span>
    <h2 class="main-title">{{ resultDetails().title }}</h2>
  </header>

  <section class="analysis">
    <h3>Constat</h3>
    <p>
      {{ resultDetails().constat }}
    </p>
  </section>

  <app-accent [title]="'La clé'">
    {{ resultDetails().key }}
  </app-accent>

  <div class="w-full text-center">
    <div class="title">
      Avoir son résultat, c'est bien. Savoir quoi en faire, c'est mieux !
    </div>
    <p-button
      icon="pi pi-heart-fill"
      label="En savoir plus"
      severity="secondary"
      [routerLink]="'/event'"
      aria-label="Accueil">
    </p-button>
  </div>
</div>
